module.exports = __webpack_public_path__ + "img/eventfinder.png.5c2214ec.webp";